<template>
  <div class="ed-grid s-to-center m-grid-3 lg-grid-3 s-center">
    <section class="comofunciona__card">
      <img
        class="comofunciona__imagen"
        src="../../img/como-funciona/practicar.svg"
        alt="elige"
      />
      <h2 class="comofunciona__titulo">Elige</h2>
      <p class="comofunciona__parrafo">El proyecto que más te guste</p>
    </section>

    <section class="comofunciona__card">
      <img
        class="comofunciona__imagen"
        src="../../img/como-funciona/registro.svg"
        alt="practicar"
      />
      <h2 class="comofunciona__titulo">Practica</h2>
      <p class="comofunciona__parrafo">
        Tus conocimientos y mejora paso a paso
      </p>
    </section>

    <section class="comofunciona__card">
      <img
        class="comofunciona__imagen"
        src="../../img/como-funciona/proyectos.svg"
        alt="proyectos"
      />
      <h2 class="comofunciona__titulo">Agrega</h2>
      <p class="comofunciona__parrafo">
        El proyecto a tu perfil de iQuela, que será tu portafolio
      </p>
    </section>
  </div>
</template>
<style scoped lang="scss">
@import "../../sass/home.scss";
img {
  color: black;
  margin-top: 25px;
}
div {
  width: 90%;
}
@media (max-width: 480px) {
  div {
    width: 90%;
    margin-left: 5%;
  }
}
</style>